import * as React from "react";
import { AlertCircle, AlertTriangle } from "react-feather";
import { HEALTH_COLORS } from "../utils";
import { InternalLink } from "../../../newcomponents/table/components/InternalLink";

interface ProcessedDomain {
  name: string;
  error: boolean;
  warning: boolean;
  status: string;
  text: string;
}

interface DomainHealthCardProps {
  domain: ProcessedDomain;
}

export const DomainHealthCard: React.FC<DomainHealthCardProps> = ({ domain }) => {
  const severity = domain.error ? "error" : "warning";
  const Icon = severity === "error" ? AlertCircle : AlertTriangle;
  const color = severity === "error" ? HEALTH_COLORS.error : HEALTH_COLORS.warning;

  return (
    <div
      className="rounded-lg p-4 overflow-hidden"
      style={{
        backgroundColor: "var(--health-card-bg)",
        border: "1px solid var(--color-border)",
      }}
    >
      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        <Icon size={16} color={color} className="flex-shrink-0" />
        <div className="truncate min-w-0 flex-1 text-sm font-medium">
          <InternalLink label={domain.name} to={`/console/org/-/domain/${domain.name}`} />
        </div>
      </div>

      {/* Status badge */}
      <div className="flex items-center gap-2 mb-2">
        <span
          className="text-xs px-2 py-0.5 rounded"
          style={{
            backgroundColor: severity === "error" ? "rgba(239, 68, 68, 0.1)" : "rgba(245, 158, 11, 0.1)",
            color,
          }}
        >
          {domain.status}
        </span>
      </div>

      {/* Message */}
      {domain.text && (
        <div
          className="text-xs truncate"
          style={{ color: "var(--color-label)" }}
          title={domain.text}
        >
          {domain.text}
        </div>
      )}
    </div>
  );
};
